import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./DayInLife.css";
import Routine from "../../Components/HeroSection/assets/Routine.png";
import { Link } from "react-router-dom";

const DayInLife = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">

        {/* Blog Heading */}
        <div className="static-header">
          <h1 className="container">A Day in the Life of an UpskillMeet Expert Mentor</h1>
        </div>

        {/* Blog Content */}
        <div className="container mt-4 blog-detail-wrapper">
          <img
            src={Routine}
            alt="A Day in the Life of an UpskillMeet Expert"
            className="blog-detail-image"
          />

          <p className="blog-meta">
            <strong>Meta Title:</strong> A Day in the Life of an UpskillMeet Expert Mentor
            <br />
            <strong>Meta Description:</strong> Discover what it's like to be an expert on UpskillMeet. From posts to sessions, learn how mentors build trust and grow their presence in the skill marketplace.
          </p>

          <div className="blog-detail-content">
            <p>
              Being an expert on UpskillMeet is more than just offering sessions .it’s about 
              showing up consistently, staying organized, and building your professional brand.
              Whether you're a student guiding peers or a professional offering business consulting, 
              here’s what a typical day might look like.
            </p>

            <h2>Start Your Day by Checking the Dashboard</h2>
            <ul>
              <li>Look for new queries from explorers</li>
              <li>See if any sessions are scheduled for the day</li>
              <li>Make sure your calendar is up to date</li>
            </ul>
            <p>Responding to queries early helps you secure bookings and shows you're active and reliable.</p>

            <h2>Review Your Scheduled Sessions</h2>
            <ul>
              <li>Confirm the time and Google Meet link</li>
              <li>Review what the session is about</li>
              <li>Prepare notes, slides, or any materials you'll need</li>
            </ul>
            <p>Being prepared helps you deliver focused and helpful sessions.</p>

            <h2>Share a Post on the Skill Market</h2>
            <p>Posting regularly keeps your profile active and visible. Use the post section to:</p>
            <ul>
              <li>Share tips or lessons from your expertise</li>
              <li>Talk about a recent successful session</li>
              <li>Promote your skills or personal projects</li>
            </ul>
            <p>This builds your identity as a skillfluencer and encourages explorers to check out your profile.</p>

            <h2>Host Your Sessions with Professionalism</h2>
            <ul>
              <li>Start the session on time via Google Meet</li>
              <li>Ask the explorer for the Start OTP before beginning</li>
              <li>Keep the session focused and interactive</li>
              <li>End by asking for the End OTP to mark completion</li>
            </ul>
            <p>Use the "No Show" option only if the explorer fails to attend.</p>

            <h2>Follow Up and Reflect</h2>
            <ul>
              <li>Check for feedback in your Completed Bookings tab</li>
              <li>Use helpful feedback to improve future sessions</li>
              <li>Update your SME list if needed</li>
            </ul>
            <p>If you had a great session, consider creating a post about it to build social proof.</p>

            <h2>Keep Your Profile Updated</h2>
            <ul>
              <li>Add new experiences or skills</li>
              <li>Post testimonials if you receive them</li>
              <li>Refresh your intro if your focus has shifted</li>
            </ul>
            <p>This shows explorers you’re active and evolving.</p>

            <h2>Final Thought</h2>
            <p>
              Being active on UpskillMeet isn’t just about showing up to sessions. It’s about:
            </p>
            <ul>
              <li>Responding to queries on time</li>
              <li>Posting content that shows your expertise</li>
              <li>Handling sessions with care and clarity</li>
              <li>Growing your presence as a reliable skillfluencer</li>
            </ul>
            <p>
              Every day is a chance to help someone learn—and to grow your reputation in the skill marketplace.  
              <strong>Go to your dashboard now.</strong>
            </p>

            <h2>Related Reads:</h2>
            <ul>
              <li>
								<Link to="/blog/what-to-post">
									What to Post on UpskillMeet
								</Link>
							</li>
              <li>
								<Link to="/blog/profile-that-gets-bookings">How to Build a Profile That Gets Bookings</Link>
							</li>
              <li>
								<Link to="/blog/book-better-sessions">Using Queries to Book Better Sessions</Link>
							</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DayInLife;
